import {
  GET_CREDIT_CHARGES_FAILURE,
  GET_CREDIT_CHARGES_REQUEST,
  GET_CREDIT_CHARGES_SUCCESS,
  GET_CREDIT_CHARGES_RESET,
} from "../constants";

const initialState = {
  creditChargesData: null,
  creditChargesLoading: false,
  creditChargesError: null,
};

export const creditChargesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_CREDIT_CHARGES_REQUEST:
      return {
        ...state,
        creditChargesLoading: true,
        creditChargesError: null,
      };

    case GET_CREDIT_CHARGES_SUCCESS:
      return {
        ...state,
        creditChargesLoading: false,
        creditChargesData: action.payload.data,
      };

    case GET_CREDIT_CHARGES_FAILURE:
      return {
        ...state,
        creditChargesLoading: false,
        creditChargesError: action.payload,
      };

    case GET_CREDIT_CHARGES_RESET:
      return initialState;

    default:
      return state;
  }
};
